/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateProOrganizerRequestDto { 
    /**
     * Reject reason
     */
    note?: string;
    /**
     * ID of the admin who reviewed or approved the request
     */
    updatedAdminById?: string;
    /**
     * Request status key
     */
    status: string;
    /**
     * Admin-defined premium role snapshot description (used for \"Other\" role)
     */
    adminDefinedRole?: string;
}

